import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface FollowerUser {
  user_id: string;
  full_name: string | null;
  avatar_url: string | null;
}

export function useUserFollowersForList(userId?: string) {
  const [followers, setFollowers] = useState<FollowerUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFollowers = async () => {
    if (!userId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      
      // Use database function to get followers list (bypasses RLS)
      const { data: followersData, error } = await supabase.rpc('get_followers_list', {
        _user_id: userId
      });

      if (error) throw error;

      setFollowers(followersData || []);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar seguidores');
      setFollowers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFollowers();
  }, [userId]);

  return {
    followers,
    loading,
    error,
    refetch: fetchFollowers
  };
}